module.exports = __webpack_public_path__ + "static/media/Brios-Semillas-Descripcion-Mobile.a2b0a87f.webp";